import React, { useState } from "react";
import { NotificationContext } from "./NotificationContext";
import { useFetch } from "hooks/api";
import axios from "axios";
import { useAppSelector } from "../redux/hooks";
import type { Notification } from "./notificationConstants";
import useInterval from "hooks/useInterval";

interface Props {
  children: React.ReactNode;
}

const NotificationProvider = ({ children }: Props) => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const isEnabled = isAuthenticated && !!axios.defaults.headers.Authorization;
  const marketPlace =
    localStorage.Marketplace && localStorage.Marketplace !== "undefined" ? localStorage.Marketplace : "USA";
  const [deCounter, setDeCounter] = useState(0);

  useInterval(() => {
    // Your custom logic here
    setDeCounter(deCounter + 1);
  }, 60000);

  const { data: notifications = [], isLoading = true } = useFetch<Notification[]>(
    ["notifications", deCounter],
    "/api/notifications/",
    {
      dismissed: false,
      market_place: marketPlace,
    },
    {
      enabled: isEnabled,
      select: (data) => data.data,
    },
  );

  // sort notifications by ts desc
  notifications.sort((a, b) => (a.ts ?? 0) - (b.ts ?? 0));
  return <NotificationContext.Provider value={{ notifications, isLoading }}>{children}</NotificationContext.Provider>;
};

export default NotificationProvider;
